import React, { useEffect, useState } from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import styled from "styled-components";
import COLORS from "common/Colors";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Input, Modal, Space, Spin } from "antd";
import { SearchOutlined } from "@mui/icons-material";
import Table from "atoms/Table";
import { ButtonFilled } from "reusableComponent/UIButtons";
import { getClientid, getUserList } from "redux/selectors";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import AddEmployee from "organisms/AddEmployee";
import { bindActionCreators } from "redux";
import { setUserList } from "redux/actions";
import { STATUS_CODE } from "common/Constants";
import { ReactComponent as DeleteIcon } from "../assets/delete_Icon.svg";
import { useParams } from "react-router-dom";

const EmployeeWrap = styled.div`
  /* Scoped to the search bar only (via .employee-search-input) so this
     grey background no longer leaks into every antd Input rendered
     inside this wrapper, e.g. the onboarding form fields. */
  .employee-search-input.ant-input-affix-wrapper {
    background-color: #f8f7f7;
    width: 380px;
  }
  .employee-search-input.ant-input-affix-wrapper .ant-input {
    background-color: #f8f7f7;
    width: 100%;
  }
  .custom-table {
    border: none !important;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  }
`;
const StyledButton = styled(Button)`
  background: #00685F !important;
  border-radius: 5px;
  color: #ffffff !important;
  width: 100px;
   &:hover {
      color: #ffffff !important;
  }
   &:focus {
      color: #ffffff !important;
  }
`;

const StyledButtonCancel = styled(Button)`
   background: #ffffff !important;
  border-radius: 5px;
  color: #000000!important;
  width: 100px;
  border-color: #000000!important;
  &:focus {
      color: #000000 !important;
  }
`;
const PendingEmployee = ({ ClientId, userList, updateUserList }) => {
  const [loader, setloader] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState();
  const [showOnboard, setShowOnboard] = useState(false)
  const [searchText, setSearchText] = useState("");
  const [pendingList, setPendingList] = useState([])
  const [filteredData, setFilteredData] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteUser, setDeleteUser] = useState(null);
  const { id } = useParams();
  const [deletingUserId, setDeletingUserId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const onboardingStatus = "onboardingEmployees";

  useEffect(() => {
    fetchPendingUserData();
  }, [])

  const history = useHistory();
  const breadStyle = { color: "#636980", cursor: "pointer" };
  const styledInput = {
    color: `${COLORS.TEXT.PRIMARY}`,
    fontSize: "16px",
    border: "none",
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
  };
  const styledIcon = { color: `${COLORS.TEXT.PRIMARY}`, fontSize: "18px" };

  const fetchMasterData = async (fetch_master_data) => {
    setloader(true);
    const { code, userList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );

    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        updateUserList(userList);
      }
      setloader(false);
    }
  };

  const fetchPendingUserData = async () => {
    setloader(true);
    const { code, response } = await CALL_API(
      `add-users/${ClientId}?statusid=2`,
      "get",
    );
    if (code === STATUS_CODE.SUCCESS) {
      setPendingList(response)
      setFilteredData(response)
      setloader(false);
    }
  };

  const handleDelete = async () => {
    if (!deleteUser) return;
    setDeleteLoading(true);
    setDeletingUserId(deleteUser.personaluserid);

    try {
      const { code } = await CALL_API(
        `add-users/${ClientId}?onboardingStatus=${onboardingStatus}`,
        "delete",
        {
          onboardid: deleteUser?.id
        }
      );

      if (code === STATUS_CODE.SUCCESS) {
        setDeleteModalVisible(false);
        setDeleteUser(null);
        fetchPendingUserData();
        fetchMasterData(true);
      }
    } catch (error) {
      console.error("Delete failed", error);
    } finally {
      setDeleteLoading(false);
      setDeletingUserId(null);
    }
  };

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "fullname",
      key: "fullname",
      render: (fullname) => (fullname ? fullname : "-"),
    },
    {
      title: "Email",
      key: "email",
      render: (email, record) => (`${record?.firstname?.toLowerCase().replace(/\s+/g, '')}${record?.lastname?.toLowerCase().replace(/\s+/g, '')}@gmail.com`),
    },
    {
      title: "Phone no.",
      dataIndex: "phoneno",
      key: "phone",
      render: (phone) => (phone ? phone : "-"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div>
          <ButtonFilled className="apply-leave-sm" onClick={() => {
            setShowOnboard(true)
            setSelectedDetails(record)
          }}> On Board </ButtonFilled>
          {deletingUserId === record.personaluserid ? (
            <Spin size="small" style={{ marginLeft: 12 }} />
          ) : (
            <DeleteIcon style={{ cursor: "pointer" }}
              onClick={() => {
                setDeleteUser(record);
                setDeleteModalVisible(true);
              }}
            />
          )}
        </div>
      ),
    },
  ];

  const breadcrumbs = [
    <label key="2" style={breadStyle} onClick={() => history.goBack()}>
      Employee
    </label>,
    <Typography key="3" color="text.primary" fontSize="18" fontWeight="500">
      Pending Employee
    </Typography>,
  ];

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    if (value === "") {
      setFilteredData(pendingList);
    } else {
      const filtered = pendingList?.filter(
        (item) =>
          item.fullname.toLowerCase().includes(value) ||
          item.personaluserid.toLowerCase().includes(value)
      );
      setFilteredData(filtered);
    }
  };

  return (
    <EmployeeWrap>
      <div className="mt-2">
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
      </div>

      {showOnboard ? <>
        <AddEmployee
          closeModal={() => { setShowOnboard(false) }}
          getEmployeeList={fetchMasterData}
          getPendingEmployeeList={fetchPendingUserData}
          EmployeeList={userList}
          selectedDetails={selectedDetails}
          defaultStep={0}
          onboarduser={true}
        />
      </> :
        <div className="mt-3">
          <Input
            className="employee-search-input"
            style={styledInput}
            prefix={<SearchOutlined style={styledIcon} />}
            placeholder="Search by name & email"
            value={searchText}
            onChange={handleSearchChange}
          />
          <div>
            <Table
              dataSource={filteredData}
              columns={columns}
              className="custom-table"
              pagination={false}
              // onRow={(record, rowIndex) => {
              //   return (
              //     setSelectedDetails(record)
              //    );
              // }}
              rowKey="personaluserid"
              loading={loader}
            />
          </div>
        </div>
      }
      <Modal
        title="Are you sure you want to delete this employee?"
        open={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        style={{ marginTop: "100px" }}
        footer={[
          <StyledButtonCancel key="cancel" onClick={() => setDeleteModalVisible(false)}>
            Cancel
          </StyledButtonCancel>,
          <StyledButton
            key="delete"
            type="primary"
            loading={deleteLoading}
            onClick={handleDelete}
            style={{
              backgroundColor: "#CA1003",
              borderColor: "#CA1003",
            }}
          >
            Delete
          </StyledButton>,
        ]}
      >
        <p>This action cannot be undone.</p>
      </Modal>
    </EmployeeWrap>
  );
};

const mapStateToProps = (state) => ({
  ClientId: getClientid(state),
  userList: getUserList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserList: setUserList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps, null)(PendingEmployee);